var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManagementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#173CBA;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M340.4,378.5H165.5c-11.3,0-19.7-12.6-18-26.5c5.2-43.2,27.3-80.5,58.1-99.7c12.8,23.6,31.6,42.2,47.4,42.2 c15.7,0,34.5-18.5,47.4-42.1c8,5,15.4,11.2,22,18.4c19.1,20.5,32.2,49.2,36.1,81.3C360,365.2,352,378.5,340.4,378.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M305.5,199.4c0,36.3-32.6,82.4-52.6,82.4s-52.6-46-52.6-82.4c0-36.3,23.6-65.9,52.6-65.9 C281.9,133.5,305.5,163.1,305.5,199.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M425.8,211.5c0,30.7-27.6,69.5-44.5,69.5c-16.9,0-44.5-38.8-44.5-69.5c0-30.8,20-55.8,44.5-55.8 S425.8,180.7,425.8,211.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M454,361.3h-85.7c0.5-3.7,0.6-7.6,0.1-11.2c-4.1-33.6-17.6-64.5-38-87.3c2.8-2.5,5.7-4.7,8.7-6.7 c11.1,21,27.8,37.5,42.2,37.5c14.4,0,31.1-16.5,42.2-37.5c24.5,16.6,42.1,46.9,46.3,82.1C471.3,350.1,463.9,361.3,454,361.3z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.2,205.9c0,30.7,27.6,69.5,44.5,69.5c16.9,0,44.5-38.8,44.5-69.5c0-30.8-20-55.8-44.5-55.8 S84.2,175.1,84.2,205.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56,355.7h85.7c-0.5-3.7-0.6-7.6-0.1-11.2c4.1-33.6,17.6-64.5,38-87.3c-2.8-2.5-5.7-4.7-8.7-6.7 c-11.1,21-27.8,37.5-42.2,37.5c-14.4,0-31.1-16.5-42.2-37.5C62,267,44.4,297.3,40.2,332.5C38.7,344.5,46.1,355.7,56,355.7z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagementIcon);
export default __webpack_public_path__ + "static/media/management-icon.9d3cfeb8f343bdd8fa69ae9dc7b56115.svg";
export { ForwardRef as ReactComponent };